export const colorSistema = {
  default: {
    100: '#f3f3f3',
    200: '#cbcbcb',
    300: '#625956',
    400: '#ffc994',
    500: '#ffffff',
    600: '#2B2A4C',
    700: '#E48F45',
    800: '#0a996f',
    900: '#3887BE',
  },
};

const mainColor = '#6366F1';

export const ColorPalleteTheme = {
  main: mainColor,
};
